<script lang="ts">
  export default {
    name: 'LegendToggle',
  };
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed,  inject, } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { TextSelect } from 'lucide-vue-next';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const legendEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.legendEnabled;
});

// ----------
// handlers
// ----------
function  handleToggleLegend(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SET_LEGEND_MODE, !store?.state.towerCanvasState.legendEnabled);
}
</script>

<template>
  <div class="tw:py-2 tw:self-end">
    <label title="Toggle Legend">
      <input
        type="checkbox"
        name="legend-toggle"
        aria-label="Legend Toggle"
        class="tw:box-border tw:pointer-events-none tw:hidden"
        @click="handleToggleLegend"
        style="display:none"
      />
      <TextSelect
        class="button toggle-button tw:border-box tw:pointer-events-auto tw:flex tw:h-10 tw:w-10 tw:cursor-pointer tw:items-center tw:rounded-lg tw:p-2 tw:shadow-lg"
        :class="{ selected: legendEnabled }"
      />
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
